import React, {useRef, useState} from 'react';
import AnimateHeight from 'react-animate-height'
import {useSelector} from 'react-redux'
import moment from 'moment'
import _ from 'lodash'

import AccommodationForm from '../Accomodation/AccommodationForm'
import BookingStepper from '../BookingStepper/BookerStepper'
import MobilePricing from './elements/MobilePricing'

import labels from '../../configuration/labels'
import { isRailBookers } from '../../configuration/brand'
import { getRAQFormUrl } from '../../configuration/deeplinking'
import {
  getAvailabilityForMobileLayout,
  getTour,
  getTourAccommodationOptions,
  getTourBookingPath,
  getTourDetailsForSoftTrip,
} from '../../redux/reducers/tourDetails'
import { onEnter } from '../../utilities/accessibility/onEnter'
import { formatRoomDetailsForDeepLinking } from '../../utilities/content/tours'
import '../../styles/scss/elements/mobile-booking.scss'

const bookingSteps = {
  details: 'tour-details',
  pricing: 'tour-pricing',
}

const DEFAULT_ROOM = {
  adults: ['A', 'A'],
  children: [],
}

const MobileBooking = ({onClose}) => {
  const accommodationOptions = useSelector(getTourAccommodationOptions)
  const availability = useSelector(getAvailabilityForMobileLayout)
  const modalHeader = useRef(null)
  const softripBookingPath = useSelector(getTourBookingPath)
  const softripDetails = useSelector(getTourDetailsForSoftTrip)
  const tour = useSelector(getTour)
  const [currentStep, setCurrentStep] = useState(bookingSteps.pricing)
  const [outgoingUrl, setOutgoingUrl] = useState(null)
  const [preAcc, setPreAcc] = useState('')
  const [postAcc, setPostAcc] = useState('')
  const [pricingCategory, setPricingCategory] = useState(0)
  const [rooms, setRooms] = useState([DEFAULT_ROOM])
  const [selectedDate, setSelectedDate] = useState(null)

  function addRoom() {
    if (_.size(rooms) < 4) {
      setRooms(_.concat(rooms, [DEFAULT_ROOM]))
    }
  }

  function removeRoom() {
    if (_.size(rooms) > 1) {
      setRooms(_.take(rooms, _.size(rooms) - 1))
    }
  }

  function updateRoom(room, index) {
    const updatedRooms = _.cloneDeep(rooms)
    updatedRooms[index] = room
    setRooms(updatedRooms)
  }

  function getSoftripURLWithPassengerInfo() {
    const date = _.get(selectedDate, 'date')
    const softTripDeepLinkURL = new URL(`${process.env.REACT_APP_BOOKING_BASE_URL}${softripBookingPath}`)
    softTripDeepLinkURL.search = new URLSearchParams({
      ...softripDetails,
      ...(preAcc && {
        Preacc: _.get(accommodationOptions, 'preAcc'),
        Preaccduration: preAcc,
      }),
      ...(postAcc && {
        Postacc: _.get(accommodationOptions, 'postAcc'),
        Postaccduration: postAcc,
      }),
      tbCheckIn: moment(date).format('YYYY-MM-DD'),
      tbCheckOut: moment(date).add(tour.duration, 'days').format('YYYY-MM-DD'),
      ...formatRoomDetailsForDeepLinking(rooms, tour.softripBooking),
      ItemNumber: _.get(availability, `[${pricingCategory}].id`),
      SelectedSeq: _.get(availability, `[${pricingCategory}].id`),
    })
    return softTripDeepLinkURL.toString()
  }

  function onSetSelectedDate(selectedDate) {
    if (isRailBookers() || !tour.softripBooking) {
      setOutgoingUrl(getRAQFormUrl(false, selectedDate.date))
    }
    setSelectedDate(selectedDate)
  }

  function onSetCurrentStep(step) {
    setCurrentStep(bookingSteps.pricing)
    if (step === bookingSteps.pricing) {
      setPreAcc('')
      setPostAcc('')
      setRooms([DEFAULT_ROOM])
    }
  }

  function onSubmit() {
    if (currentStep === bookingSteps.pricing) {
      if (outgoingUrl) {
        window.location.href = outgoingUrl
      } else {
        setCurrentStep(bookingSteps.details)
        if (modalHeader.current) {
          modalHeader.current.scrollIntoView()
        }
      }
    }
    if (currentStep === bookingSteps.details) {
      window.location.href = getSoftripURLWithPassengerInfo()
    }
  }

  return (
    <div className="mobile-booking">
      <div
        className="modal-close"
        role="button"
        onClick={onClose}
        onKeyDown={(event) => onEnter(event, onClose)}
        ref={modalHeader}
        tabIndex="0"
      />
      <AnimateHeight height={isRailBookers() ? 0 : 105}>
        <BookingStepper
          currentStep={currentStep}
          isMobile
          onSetCurrentStep={onSetCurrentStep}
        />
      </AnimateHeight>
      <div className="u-flex u-flex-column u-flex-align-center mobile-booking__content">
        {currentStep === bookingSteps.pricing && (
          <MobilePricing
            onSelectPricingCategory={setPricingCategory}
            onSetSelectedDate={onSetSelectedDate}
            pricing={_.get(availability, `[${pricingCategory}].pricing`)}
            pricingCategories={_.map(availability, category => category.title)}
            selectedDate={_.get(selectedDate, 'date')}
            selectedPricingCategoryIndex={pricingCategory}
          />
        )}
        {currentStep === bookingSteps.details && (
          <div className="u-full-width u-flex u-flex-column u-flex-align-center mobile-booking__content__passenger-info">
            <h2>{labels.passengerInfo}</h2>
            <AccommodationForm
              accommodationOptions={accommodationOptions}
              rooms={rooms}
              addRoom={addRoom}
              removeRoom={removeRoom}
              updateRoom={updateRoom}
              preAcc={preAcc}
              setPreAcc={setPreAcc}
              postAcc={postAcc}
              setPostAcc={setPostAcc}
            />
          </div>
        )}
        {Boolean(outgoingUrl || selectedDate) && (
          <button
            aria-label={isRailBookers() ? labels.bookingRequestQuote : labels.bookingNextStep}
            className="u-flex u-flex-align-center mobile-booking__content__submit-button"
            disabled={!selectedDate}
            onClick={onSubmit}
            tabIndex="0"
          >
            {isRailBookers() || !tour.softripBooking ? labels.bookingRequestQuote : labels.bookingNextStep}
          </button>
        )}
      </div>
    </div>
  )
}

export default MobileBooking
